// IRIS Limit Controller (Greek checkout)
// IRIS has amount limits (see IrisRules on the server, which re-checks on
// submit). While the order total is above what IRIS allows, the IRIS option
// is switched off and a short notice explains why.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "radio", "notice"]
  static values = { max: Number }

  connect() {
    // The order form may have announced its first total before we connected.
    setTimeout(() => this.apply(this.totalOnPage()), 0)
  }

  check(event) {
    this.apply(event.detail.total)
  }

  apply(total) {
    const over = Number(total) > this.maxValue
    this.radioTarget.disabled = over
    this.optionTarget.classList.toggle("opacity-50", over)
    this.optionTarget.classList.toggle("pointer-events-none", over)
    this.noticeTarget.classList.toggle("hidden", !over)
    if (over && this.radioTarget.checked) {
      this.radioTarget.checked = false
      this.radioTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  totalOnPage() {
    const shown = document.querySelector("[data-order-form-target='totalDisplay']")
    const number = shown ? parseFloat(shown.textContent.replace(/[^0-9.]/g, "")) : 0
    return Number.isFinite(number) ? number : 0
  }
}
